module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/gifs/email-integration-4-new-contact.gif"